<template>
	<div class="d-flex h-100 classic-dashboard" style="gap: .5em">
		<b-card no-body header="Channels" class="d-flex flex-column overflow-hidden">
			<template #header>
				Channels
				<div class="float-right">
					<a class="btn btn-default btn-sm card-header-btn" target="_blank" :href="`${$baseUrl}/app/channelList.html`" @click.prevent="openPopup(`${$baseUrl}/app/channelList.html`, 400, 700)" title="Pop out channel list"><b-icon icon="box-arrow-up-right"></b-icon></a>
					<b-button v-if="!!restreamingData" v-b-toggle.collapse-video size="sm" class="card-header-btn" variant="primary">Preview <b-icon icon="arrows-expand"></b-icon></b-button>
				</div>
			</template>
			<b-collapse v-if="restreamingData" id="collapse-video" ref="collapseVideo" v-model="showRestreamingPreview">
				<b-aspect aspect="16:9" style="background: black; line-height: 0">
					<div v-if="showRestreamingPreview && restreamingData?.status?.status == 'live'" style="position: relative; height: 100%">
						<div style="position: absolute; left: 0; top:0; right: 0; line-height: 1em" class="p-1">
							<b-badge :variant="restreamingData.status.status == 'live' ? 'primary' : 'default'">{{restreamingData.status.status.toUpperCase()}}</b-badge>
							<b-badge variant="secondary" class="ml-1">{{restreamingData.status.uptime}}</b-badge>
						</div>
						<div v-if="videoLoading" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; line-height: 300px; text-align: center; vertical-align: middle">
							<b-icon icon="circle-fill" animation="throb"></b-icon>
						</div>
						<hls-player ref="player" :source="restreamingData.playbackUrlSecure||restreamingData.playbackUrl" @hlsManifestLoading="videoLoading=true" @hlsInitPtsFound="videoLoading=false" @muted="muted=true" @unmuted="muted=false" @pause="playing = false" @play="playing = true"></hls-player>
						<div style="position: absolute; bottom: 0; left: 0; right: 0; line-height: 1em" class="p-1">
							<button type="button" class="btn btn-secondary btn-sm m-1" @click="$refs.player.togglePause()"><b-icon :icon="playing?'pause-fill':'play-fill'"/></button>
							<button type="button" class="btn btn-secondary btn-sm m-1" @click="$refs.player.toggleMute()"><b-icon :icon="muted?'volume-up-fill':'volume-mute-fill'"/></button>
						</div>
					</div>
					<div v-else style="padding: 70px 50px 0">
						<br /><br />
						<b-input-group prepend="Restreaming service" label-for="restreaming-service-name" size="sm" class="mb-2">
							<b-form-input id="restreaming-service-name" size="sm" readonly :value="restreamingData.serviceName" />
						</b-input-group>
						<b-input-group prepend="SRT URL" label-for="srt-url" size="sm" class="mb-2">
							<b-form-input id="srt-url" placeholder="srt://" readonly :value="restreamingData.srtUrl" @focus="$event.target.select()"/>
							<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.srtUrl, 'Copied SRT URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
						</b-input-group>
						<b-input-group prepend="RTMP URL" label-for="rtmp-url" size="sm" class="mb-2">
							<b-form-input id="rtmp-url" placeholder="rtmp://" readonly :value="restreamingData.rtmpUrl" @focus="$event.target.select()"/>
							<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpUrl, 'Copied RTMP URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
						</b-input-group>
						<b-input-group prepend="Stream key" label-for="rtmp-key" size="sm" class="mb-2">
							<b-form-input id="rtmp-key" readonly :type="showRtmpKey?'text':'password'" :value="restreamingData.rtmpKey" @focus="$event.target.select()"/>
							<b-input-group-append><b-button variant="outline-info" @click="showRtmpKey=!showRtmpKey"><b-icon icon="eye"></b-icon></b-button></b-input-group-append>
							<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpKey, 'Copied stream key to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
						</b-input-group>
						<div class="text-right">
							<b-button variant="warning" size="sm" @click="$refs.streamResetModal.show()">Reset stream</b-button>
						</div>
					</div>
				</b-aspect>
			</b-collapse>
			<div class="p-3" v-if="!!restreamingData || user.title_status == 'enabled'">
				<b-spinner v-if="loading>0" small label="Spinning" class="ml-3"></b-spinner>
				<div v-else class="d-flex align-items-start">
					<div class="flex-fill overflow-hidden">
						<template v-if="user.title_status == 'enabled'">
							<b-media no-body>
								<b-media-aside v-if="user.stream_thumbnail_url" class="mr-3">
									<b-img :src="user.stream_thumbnail_url" width="120" rounded thumbnail alt="Stream thumbnail"></b-img>
								</b-media-aside>
								<b-media-body class="overflow-hidden">
									<div class="text-truncate"><span v-if="user && user.stream_title">{{user.stream_title}}</span><i v-else class="text-muted">Please set a title</i></div>
									<p v-if="resolvedDescription" class="small text-muted mb-0 stream-details-desc">{{resolvedDescription}}</p>
								</b-media-body>
							</b-media>
						</template>
						<i v-else class="text-muted">Automatic stream titles disabled</i>
					</div>
					<b-dropdown variant="link" no-caret right toggle-class="text-decoration-none text-body p-0" class="ml-2">
						<template #button-content><b-icon icon="three-dots-vertical"></b-icon></template>
						<b-dropdown-item @click="$refs.metadataModal.show()">Edit titles</b-dropdown-item>
						<b-dropdown-item @click="$refs.scheduleModal.show()">Schedule event</b-dropdown-item>
						<b-dropdown-item @click="clearScheduledPosts">Clear scheduled posts</b-dropdown-item>
						<b-dropdown-item @click="$refs.notifyModal.show()">Send notifications</b-dropdown-item>
						<b-dropdown-item v-if="!!restreamingData" @click="$refs.streamResetModal.show()">Reset stream</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>
			<b-alert :show="!!error" variant="danger" class="m-2">{{error&&(error.error||error.toString())}}</b-alert>
			<div class="h-100 d-flex flex-column overflow-hidden">
				<div class="flex-fill overflow-auto">
					<channel-list @updated="$refs.chatLog?.bottomOut()" @edit="$refs.channelModal.showEdit($event.service_id, $event.token)" ref="channelList"></channel-list>
				</div>
				<div class="p-2">
					<b-button class="w-100" variant="primary" @click="$refs.channelModal.show()">Add channel</b-button>
				</div>
			</div>
			<channel-modal ref="channelModal" @saved="onChannelSaved"></channel-modal>
			<stream-reset-modal ref="streamResetModal" @saved="$emit('reload-restreaming')" />
			<b-modal ref="metadataModal" title="Stream details" @show="loadMetadata" @ok.prevent="saveMetadata">
				<b-form-group>
					<b-form-checkbox switch inline class="mr-0" v-model="metadata.title_status" value="enabled" unchecked-value="disabled">Enable automatic titles and posts</b-form-checkbox>
				</b-form-group>
				<template v-if="metadata.title_status == 'enabled'">
					<b-form-group label="Title">
						<b-input ref="titleInput" v-model="metadata.stream_title_template" @focus="lastFocusedField='title'"></b-input>
						<div class="p-1 text-info">{{replaceTemplateTags(metadata.stream_title_template, metadata)}}</div>
					</b-form-group>
					<b-form-group label="Description">
						<b-textarea ref="descInput" v-model="metadata.stream_description_template" @focus="lastFocusedField='description'"></b-textarea>
						<div class="p-1 text-info">{{replaceTemplateTags(metadata.stream_description_template, metadata)}}</div>
					</b-form-group>
					<b-form-text class="mb-3">
						Click to insert a tag:
						<a href="#" @click.prevent="insertTag('{EPISODE}')"><code>{EPISODE}</code></a> for the episode number, or
						<a href="#" @click.prevent="insertTag('{DATE}')"><code>{DATE}</code></a> for the stream date.
						When you schedule an event, <code>{DATE}</code> uses the scheduled date instead of today's.
					</b-form-text>
				</template>
				<b-form-group label="Episode number" v-if="metadata.title_status == 'enabled'">
					<b-input type="number" min="1" v-model="metadata.stream_episode_number"></b-input>
				</b-form-group>
				<b-form-group label="Thumbnail" v-if="metadata.title_status == 'enabled'">
					<b-form-row>
						<b-col cols="3">
							<b-img v-if="metadata.stream_thumbnail_url" :src="metadata.stream_thumbnail_url" fluid rounded thumbnail></b-img>
						</b-col>
						<b-col>
							<b-form-file accept="image/*" @change="onThumbnailChange" :disabled="thumbnailUploading > 0"></b-form-file>
							<b-form-text>Max 1280×720 (larger images are scaled down), 50MB.</b-form-text>
							<b-progress v-if="thumbnailProgress != null" :value="thumbnailProgress" max="100" height="4px" class="mt-1"></b-progress>
							<div v-if="thumbnailError" class="small text-danger mt-1">⚠ {{thumbnailError}}</div>
							<b-button v-if="metadata.stream_thumbnail_url" size="sm" variant="link" class="text-danger p-0 mt-1" @click="metadata.stream_thumbnail_url = null">Remove thumbnail</b-button>
						</b-col>
					</b-form-row>
				</b-form-group>
				<template v-if="metadata.title_status == 'enabled'">
					<service-fields-editor ref="serviceFields" :service-icons="serviceIcons"></service-fields-editor>
				</template>
				<b-alert :show="!!metadataError" variant="danger" class="m-2">{{metadataError&&(metadataError.metadataError||metadataError.toString())}}</b-alert>
				<template #modal-footer="{ cancel: cancel_fn, ok: ok_fn }">
					<div class="w-100">
						<div class="float-right">
							<b-spinner v-show="metadataLoading>0" small label="Spinning" class="mr-3"></b-spinner>
							<b-button variant="primary" type="submit" @click="ok_fn()" class="mr-2">Update</b-button>
							<b-button @click="cancel_fn()">Close</b-button>
						</div>
					</div>
				</template>
			</b-modal>
			<b-modal ref="scheduleModal" title="Schedule event" :hide-footer="false" @show="prefillScheduleTime">
				<p class="text-muted">Create a scheduled post on your connected platforms using your stream details. Platforms that support scheduling (e.g. YouTube) create an upcoming broadcast; the others just have their title set.</p>
				<b-form-group label="Title">
					<b-form-input :value="scheduledTitle" readonly></b-form-input>
				</b-form-group>
				<b-form-group label="Description" v-if="user.stream_description_template">
					<b-form-textarea :value="scheduledDescription" readonly rows="2"></b-form-textarea>
				</b-form-group>
				<b-form-row v-if="user.stream_thumbnail_url" class="mb-2">
					<b-col cols="4"><b-img :src="user.stream_thumbnail_url" fluid rounded thumbnail></b-img></b-col>
				</b-form-row>
				<b-form-group label="Scheduled start">
					<b-form-row>
						<b-col cols="12" sm="8" class="mb-2 mb-sm-0">
							<label class="small text-muted mb-1">Date</label>
							<b-form-datepicker v-model="scheduleDate" :min="minScheduleDate" placeholder="Pick a date" today-button reset-button locale="en"></b-form-datepicker>
						</b-col>
						<b-col cols="12" sm="4">
							<label class="small text-muted mb-1 d-block text-truncate">{{user.timezone || 'UTC'}}</label>
							<b-form-select v-model="scheduleTime" :options="timeOptions"></b-form-select>
						</b-col>
					</b-form-row>
					<b-form-text class="mt-2"><code>{DATE}</code> in your title/description uses this date.</b-form-text>
				</b-form-group>
				<b-form-checkbox v-model="scheduleNotify" class="mt-2">Open the Send notification modal</b-form-checkbox>
				<b-alert :show="!!scheduleError" variant="danger">{{scheduleError && (scheduleError.error || scheduleError.message || scheduleError.toString())}}</b-alert>
				<template #modal-footer="{ cancel }">
					<b-spinner v-show="scheduling" small class="mr-auto"></b-spinner>
					<b-button @click="cancel()">Cancel</b-button>
					<b-button variant="primary" @click="scheduleEvent" :disabled="scheduling || !scheduleAt">Create scheduled posts</b-button>
				</template>
			</b-modal>
			<b-modal ref="notifyModal" title="Send notifications" @ok.prevent="sendNotificationNow" @show="loadNotificationPreview">
				<div class="text-center py-3" v-if="notifyLoading"><b-spinner small></b-spinner></div>
				<template v-else>
					<b-alert :show="!notify.notificationsConfigured || !notify.hasWebhooks" variant="warning">
						{{ !notify.notificationsConfigured ? 'Notifications are not available on this server.' : 'No notification destinations are configured.' }}
						<router-link to="/settings/notifications">Notification settings</router-link>
					</b-alert>
					<b-form-group label="Message">
						<b-textarea v-model="notify.message" rows="6"></b-textarea>
					</b-form-group>
					<b-form-group v-if="notify.thumbnailUrl">
						<b-form-row>
							<b-col cols="4"><b-img :src="notify.thumbnailUrl" fluid rounded thumbnail></b-img></b-col>
							<b-col class="d-flex align-items-center">
								<b-form-checkbox v-model="notify.includeThumbnail">Include thumbnail</b-form-checkbox>
							</b-col>
						</b-form-row>
					</b-form-group>
					<div class="small text-muted">
						Last notification sent: {{ notify.lastSentAt ? formatDateTime(notify.lastSentAt) : 'never' }}
						· <router-link to="/settings/notifications">Notification settings</router-link>
					</div>
					<b-alert :show="!!notifyError" variant="danger" class="mt-2 mb-0">{{notifyError && (notifyError.error || notifyError.message || notifyError.toString())}}</b-alert>
				</template>
				<template #modal-footer="{ cancel }">
					<b-spinner v-show="notifySending" small class="mr-auto"></b-spinner>
					<b-button @click="cancel()">Cancel</b-button>
					<b-button variant="primary" @click="sendNotificationNow" :disabled="notifySending || notifyLoading || !notify.hasWebhooks || !notify.notificationsConfigured">Send</b-button>
				</template>
			</b-modal>
		</b-card>
		<b-card no-body class="d-flex flex-column overflow-hidden">
			<template #header>
				<b-dropdown class="current-log" variant="link" no-caret toggle-class="text-decoration-none text-body">
					<template #button-content>{{currentLog === 'alerts' ? 'Alerts' : 'Chat log'}} <b-icon icon="chevron-down"></b-icon></template>
					<b-dropdown-item @click="currentLog = 'chat'">Chat log</b-dropdown-item>
					<b-dropdown-item @click="currentLog = 'alerts'">Alerts</b-dropdown-item>
				</b-dropdown>
				<div class="float-right">
					<a v-if="currentLog === 'alerts'" class="btn btn-default btn-sm card-header-btn" target="_blank" :href="`${$baseUrl}/app/alerts.html`" @click.prevent="openPopup(`${$baseUrl}/app/alerts.html`, 400, 700)" title="Pop out alerts log"><b-icon icon="box-arrow-up-right"></b-icon></a>
					<a v-else class="btn btn-default btn-sm card-header-btn" target="_blank" :href="`${$baseUrl}/app/chat.html`" @click.prevent="openPopup(`${$baseUrl}/app/chat.html`, 400, 700)" title="Pop out chat log"><b-icon icon="box-arrow-up-right"></b-icon></a>
				</div>
			</template>
			<chat-log v-if="currentLog === 'chat'" class="flex-fill" :serviceIcons="serviceIcons" ref="chatLog"></chat-log>
			<alert-log v-else class="flex-fill" :serviceIcons="serviceIcons" ref="alertLog"></alert-log>
		</b-card>
	</div>
</template>

<script>
import HlsPlayer from './HlsPlayer.vue';
import ChannelList from './ChannelList.vue';
import ChannelModal from './Channel/Modal/ChannelModal';
import ChatLog from './ChatLog.vue';
import AlertLog from './AlertLog.vue';
import StreamResetModal from './User/Modal/StreamReset.vue';
import ServiceFieldsEditor from './ServiceFieldsEditor.vue';

export default {
	name: 'ClassicDashboard',
	components: { HlsPlayer, ChannelList, ChannelModal, ChatLog, AlertLog, StreamResetModal, ServiceFieldsEditor },
	props: {
		user: { type: Object, default: () => ({}) },
		restreamingData: { type: Object, default: null },
		serviceIcons: { type: Object, default: () => ({}) },
		loading: { type: Number, default: 0 },
		error: { type: [Object, String], default: null },
	},
	data() { return {
		muted: true,
		playing: false,
		videoLoading: false,
		showRestreamingPreview: localStorage.getItem('showRestreamingPreview') == 'true',
		showRtmpKey: false,
		currentLog: localStorage.getItem('currentLog') || 'chat',
		metadata: {},
		metadataError: null,
		metadataLoading: 0,
		thumbnailUploading: 0,
		thumbnailProgress: null,
		thumbnailError: null,
		lastFocusedField: 'title',
		scheduleDate: '',
		scheduleTime: '',
		scheduling: false,
		scheduleError: null,
		scheduleNotify: true,
		notify: { message: '', thumbnailUrl: null, lastSentAt: null, hasWebhooks: false, notificationsConfigured: false, includeThumbnail: true },
		notifyLoading: false,
		notifySending: false,
		notifyError: null,
	}},
	computed: {
		scheduleAt() {
			if(!this.scheduleDate || !this.scheduleTime) return '';
			return this.wallTimeToUtcISO(this.scheduleDate, this.scheduleTime, this.user.timezone || 'UTC');
		},
		timeOptions() {
			const opts = [{ value: '', text: 'Select a time…', disabled: true }];
			for(let h = 0; h < 24; h++)
				for(const m of [0, 30]) {
					const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
					const h12 = h % 12 === 0 ? 12 : h % 12;
					opts.push({ value, text: `${h12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}` });
				}
			return opts;
		},
		minScheduleDate() {
			const d = new Date();
			const pad = n => String(n).padStart(2, '0');
			return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
		},
		scheduledTitle() {
			return this.replaceTemplateTags(this.user.stream_title_template, this.user, this.scheduleAt || undefined);
		},
		scheduledDescription() {
			return this.replaceTemplateTags(this.user.stream_description_template, this.user, this.scheduleAt || undefined);
		},
		resolvedDescription() {
			if(!this.user.stream_description_template) return '';
			return this.replaceTemplateTags(this.user.stream_description_template, this.user);
		},
	},
	watch: {
		showRestreamingPreview(v) { localStorage.setItem('showRestreamingPreview', v ? 'true' : 'false'); },
		currentLog(v) { localStorage.setItem('currentLog', v); },
	},
	methods: {
		openPopup(url, width, height) {
			window.open(url, 'winname', `directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=${width},height=${height}`);
		},
		copyAndToast(string, message, event) {
			let target;
			if(event) {
				target = event.target;
				while(target && target.nodeName != 'DIV') target = target.parentNode;
			}
			this.$util.copyToClipboard(string, target);
			this.$bvToast.toast(message, { title: 'Success', variant: 'success', solid: true });
		},
		onChannelSaved() {
			this.$refs.channelList?.channelPoller?.start();
			this.$emit('reload-user');
		},
		replaceTemplateTags(str, data, date) {
			const d = date ? new Date(date) : new Date();
			const dateStr = isNaN(d) ? '' : d.toLocaleDateString('en-US', { timeZone: (data && data.timezone) || 'UTC' });
			return (str||'Live with LiveJoiner')
				.replace(/\{episode\}/gi, data.stream_episode_number)
				.replace(/\{date\}/gi, dateStr);
		},
		prefillScheduleTime() {
			const d = new Date(Date.now() + 2 * 60 * 60 * 1000);
			const pad = n => String(n).padStart(2, '0');
			const m = d.getMinutes() < 30 ? 30 : 0;
			if(m === 0) d.setHours(d.getHours() + 1);
			this.scheduleDate = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
			this.scheduleTime = `${pad(d.getHours())}:${pad(m)}`;
		},
		wallTimeToUtcISO(dateStr, timeStr, timeZone) {
			const asUtc = new Date(`${dateStr}T${timeStr}:00Z`);
			if(isNaN(asUtc)) return '';
			try {
				const dtf = new Intl.DateTimeFormat('en-US', { timeZone, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
				const p = Object.fromEntries(dtf.formatToParts(asUtc).map(x => [ x.type, x.value ]));
				const hour = p.hour === '24' ? '00' : p.hour;
				const asZoned = Date.UTC(+p.year, +p.month - 1, +p.day, +hour, +p.minute, +p.second);
				return new Date(asUtc.getTime() - (asZoned - asUtc.getTime())).toISOString();
			} catch(e) {
				const local = new Date(`${dateStr}T${timeStr}`);
				return isNaN(local) ? '' : local.toISOString();
			}
		},
		insertTag(tag) {
			const isDesc = this.lastFocusedField === 'description';
			const ref = isDesc ? this.$refs.descInput : this.$refs.titleInput;
			const model = isDesc ? 'stream_description_template' : 'stream_title_template';
			const el = ref && ref.$el;
			const val = this.metadata[model] || '';
			if(!el || el.selectionStart == null) {
				this.$set(this.metadata, model, val + tag);
				return;
			}
			const start = el.selectionStart, end = el.selectionEnd;
			this.$set(this.metadata, model, val.slice(0, start) + tag + val.slice(end));
			this.$nextTick(() => {
				el.focus();
				const pos = start + tag.length;
				el.setSelectionRange(pos, pos);
			});
		},
		async scheduleEvent() {
			this.$refs.scheduleModal.hide();
			try {
				this.scheduling = true;
				this.scheduleError = null;
				this.$refs.channelList?.markScheduling?.(this.scheduleAt);
				const { results } = await this.$api.post('scheduleEvent', { scheduledStartTime: this.scheduleAt });
				const failed = (results || []).filter(r => r.error);
				this.$bvToast.toast(failed.length ? `Scheduled with ${failed.length} error(s) - see the channel list` : 'Scheduled posts created', {
					title: failed.length ? 'Partial success' : 'Success', variant: failed.length ? 'warning' : 'success', solid: true,
				});
				this.$refs.channelList?.channelPoller?.start();
				if(this.scheduleNotify) this.$nextTick(() => this.$refs.notifyModal?.show());
			} catch(e) {
				this.scheduleError = e;
			} finally {
				this.scheduling = false;
			}
		},
		async clearScheduledPosts() {
			const ok = await this.$bvModal.msgBoxConfirm('Cancel all scheduled posts across your channels?', { title: 'Clear scheduled posts', okVariant: 'danger', okTitle: 'Clear', centered: true });
			if(!ok) return;
			try {
				const { results } = await this.$api.post('clearScheduledPosts');
				const failed = (results || []).filter(r => r.error);
				this.$bvToast.toast(failed.length ? `Cleared with ${failed.length} error(s)` : 'Scheduled posts cleared', {
					title: failed.length ? 'Partial success' : 'Success', variant: failed.length ? 'warning' : 'success', solid: true,
				});
				this.$refs.channelList?.channelPoller?.start();
			} catch(e) {
				this.$bvToast.toast(e.error || e.message || String(e), { title: 'Error', variant: 'danger', solid: true });
			}
		},
		formatDateTime(v) {
			if(!v) return '';
			const d = new Date(v);
			return isNaN(d) ? '' : d.toLocaleString();
		},
		async loadNotificationPreview() {
			try {
				this.notifyLoading = true;
				this.notifyError = null;
				const d = await this.$api.get('notificationPreview');
				this.notify = { ...d, includeThumbnail: !!d.thumbnailUrl && d.includeThumbnail };
			} catch(e) {
				this.notifyError = e;
			} finally {
				this.notifyLoading = false;
			}
		},
		async sendNotificationNow() {
			try {
				this.notifySending = true;
				this.notifyError = null;
				await this.$api.post('sendNotification', { message: this.notify.message, includeThumbnail: this.notify.includeThumbnail });
				this.$bvToast.toast('Notification sent', { title: 'Success', variant: 'success', solid: true });
				this.$refs.notifyModal.hide();
			} catch(e) {
				this.notifyError = e;
			} finally {
				this.notifySending = false;
			}
		},
		async loadMetadata() {
			try {
				this.metadataError = null;
				this.metadataLoading++;
				this.metadata = {};
				this.metadata = await this.$api.get('userData');
			} catch(e) {
				this.metadataError = e;
			} finally {
				this.metadataLoading--;
			}
		},
		async onThumbnailChange(e) {
			const file = e.target.files?.[0];
			if(!file) return;
			try {
				this.thumbnailError = null;
				this.thumbnailProgress = 0;
				this.thumbnailUploading++;
				const { url } = await this.$api.uploadThumbnail(file, p => { this.thumbnailProgress = p; });
				this.$set(this.metadata, 'stream_thumbnail_url', url);
			} catch(err) {
				this.thumbnailError = err.message || String(err);
			} finally {
				this.thumbnailProgress = null;
				this.thumbnailUploading--;
			}
		},
		waitForThumbnail() {
			if(this.thumbnailUploading === 0) return Promise.resolve();
			return new Promise(resolve => {
				const unwatch = this.$watch('thumbnailUploading', val => {
					if(val === 0) { unwatch(); resolve(); }
				});
			});
		},
		async saveMetadata() {
			try {
				this.metadataError = null;
				this.metadataLoading++;
				await this.waitForThumbnail();
				if(this.thumbnailError) throw new Error(this.thumbnailError);
				await this.$api.post('userData', {
					stream_title_template: this.metadata.stream_title_template,
					stream_description_template: this.metadata.stream_description_template,
					stream_category_id: this.metadata.stream_category_id,
					stream_episode_number: this.metadata.stream_episode_number,
					stream_thumbnail_url: this.metadata.stream_thumbnail_url || null,
					title_status: this.metadata.title_status,
					timezone: this.metadata.timezone,
				});
				if(this.$refs.serviceFields) {
					await Promise.all(this.$refs.serviceFields.getSettings().map(c =>
						this.$api.patch(`channel/${encodeURIComponent(c.service_id)}/${encodeURIComponent(c.token)}`, { stream_settings: c.settings })
					));
				}
				this.$emit('reload-user');
				this.$refs.metadataModal.hide();
			} catch(e) {
				console.error(e);
				this.metadataError = e;
			} finally {
				this.metadataLoading--;
			}
		},
	},
};
</script>

<style>
.classic-dashboard {
	flex-direction: column;
}
.classic-dashboard > .card {
	flex: 1;
	min-height: 0;
}
@media (min-aspect-ratio: 4/3) {
	.classic-dashboard {
		flex-direction: row;
	}
}
.classic-dashboard .current-log {
	position: relative;
	display: inline-block;
	margin: -.75rem 0 -.75rem -1.25rem;
	vertical-align: middle;
}
.classic-dashboard .current-log > button.btn.dropdown-toggle {
	padding: 0.7rem 1.25rem;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}
.classic-dashboard .card-header-btn {
	margin: -10px 10px -10px 0px;
}
.classic-dashboard .card-header-btn:last-child {
	margin-right: -10px;
}
.classic-dashboard .stream-details-desc {
	white-space: pre-wrap;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>
